$(document).on('turbo:load turbo:render', () => {

    enableIfValid();
    $("#reportingPeriodStart").on("change", ()=>{
        enableIfValid();
    } )

    $("#reportingPeriodEnd").on("change", ()=>{
        enableIfValid();
    } )


    $("#reportingPeriodStartClear").on("click", ()=>{
        enableIfValid();

    })
    $("#reportingPeriodEndClear").on("click", ()=>{
        enableIfValid();

    })





});

function enableIfValid() {
    let $reportingPeriodStart = $("#reportingPeriodStart");
    let $reportingPeriodEnd = $("#reportingPeriodEnd");

    if ($reportingPeriodEnd.val() == "" || $reportingPeriodStart.val() == ""){

        $("#createDisclosure").prop("disabled", true)
    }
    else{
        $("#createDisclosure").prop("disabled", false)

    }
}